import {
  GraphQLFieldConfig,
  GraphQLNonNull,
  GraphQLInputObjectType,
  GraphQLID,
  GraphQLString
} from 'graphql'
import {
  GenericMutationResponseType,
  GenericMutationResponse
} from '../types/generic-mutation-response'
import { Context } from '../shared'

export interface UpdateEmailDomainsMutationArgs {
  readonly input: {
    readonly organizationID: string
    readonly domains: string
  }
}

const updateEmailDomainsArgs = {
  input: {
    type: new GraphQLInputObjectType({
      name: 'UpdateEmailDomainsMutationArg',
      description:
        'Mutation input type for updating an organization email domain allowlist',
      fields: () => ({
        organizationID: {
          description:
            'The ID of the organization that the email domain allowlist belongs to',
          type: new GraphQLNonNull(GraphQLID)
        },
        domains: {
          description: 'A comma-separated list of email domains to allowlist',
          type: new GraphQLNonNull(GraphQLString)
        }
      })
    })
  }
}

export const updateEmailDomains: GraphQLFieldConfig<
  any,
  Context,
  UpdateEmailDomainsMutationArgs
> = {
  description: 'Update an organization email domain allowlist',
  type: new GraphQLNonNull(GenericMutationResponseType),
  args: updateEmailDomainsArgs,
  resolve: async (_source, args, context): Promise<GenericMutationResponse> => {
    if (!args.input) {
      throw new Error('mutation input parameter is required')
    }

    const { organizationID, domains } = args.input

    await context.connector.put(`${organizationID}/email/domain/allowlist`, {
      organization_id: organizationID,
      domains
    })

    return {
      _placeholder: true
    }
  }
}
